import React from 'react';
import styles from './Skeleton.module.css';
import { classNames } from '../../utils/helpers';

function Skeleton({
  width,
  height,
  variant = 'text',
  className,
  ...props
}) {
  const style = {
    width: width,
    height: height,
  };

  return (
    <div
      className={classNames(styles.skeleton, styles[variant], className)}
      style={style}
      {...props}
    />
  );
}

function SkeletonCard({ lines = 3 }) {
  return (
    <div className={styles.card}>
      <Skeleton variant="rectangular" height={20} width="60%" />
      <div className={styles.cardContent}>
        {Array.from({ length: lines }).map((_, i) => (
          <Skeleton
            key={i}
            variant="text"
            width={i === lines - 1 ? '40%' : '100%'}
          />
        ))}
      </div>
    </div>
  );
}

Skeleton.Card = SkeletonCard;

export default Skeleton;
